import { type Exporter, GENERATED_BY } from "./types";

const NAMES = [
  "black",
  "red",
  "green",
  "yellow",
  "blue",
  "magenta",
  "cyan",
  "white",
  "bright black",
  "bright red",
  "bright green",
  "bright yellow",
  "bright blue",
  "bright magenta",
  "bright cyan",
  "bright white",
];

export const cursorAgent: Exporter = {
  id: "cursor-agent",
  label: "Cursor Agent",
  app: true,
  description: "No theme file: the CLI draws with the terminal's ANSI palette.",
  run: (ctx) => {
    const { color, theme, appName } = ctx;
    const table = [
      `# ${appName}: "${theme.name}" ANSI palette, ${GENERATED_BY}`,
      `background  ${color("terminal.background")}`,
      `foreground  ${color("terminal.foreground")}`,
      ...NAMES.map(
        (n, i) => `${String(i).padStart(2)} ${n.padEnd(15)} ${color(`terminal.ansi${i}`)}`,
      ),
    ].join("\n");
    return {
      files: [
        {
          path: "(reference only: the terminal palette)",
          filename: `${appName}.cursor-agent.txt`,
          language: "text",
          content: `${table}\n`,
        },
      ],
      steps: [
        `Cursor Agent (\`cursor-agent\` / \`agent\`) has no color-theme setting as of build 2026.10.22: it renders with the terminal's 16 ANSI colors. Apply the matching Ghostty theme (\`theme = ${appName}\` in \`~/.config/ghostty/config\`) so Cursor Agent uses the palette below.`,
        "Check `~/.cursor/cli-config.json` and `agent --help` for a newer `theme`/`colors` option. If one exists, map the palette below onto it; otherwise change nothing in Cursor's config.",
      ],
      verify: ["Start `agent` in Ghostty and confirm that diffs and prompts use the colors below."],
      notes: [],
    };
  },
};
